module.exports = __webpack_public_path__ + "img/plan2.527b9edc.svg";